import axios from "axios";

export default {
  namespaced: true,
  state: {
    payrollentries: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    currentEmployeeId: null,
  },
  mutations: {
    UPDATED_CURRENT_EMPLOYEEID(state, id) {
      state.currentEmployeeId = id;
    },
    RECEIVED_PAYROLL_ENTRIES(state, payload) {
      state.payrollentries = payload;
      state.isReceiving = false;
    },
    RECEIVING_PAYROLL_ENTRIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_PAYROLL_ENTRY(state, payload) {
      state = Object.assign(state, {
        payrollentries: [...state.payrollentries, payload],
        isReceiving: false,
        currentEmployeeId: payload.employeeid,
      })
    },
    RECEIVING_PAYROLL_ENTRY(state) {
      state.isReceiving = true;
    },
    UPDATED_PAYROLL_ENTRY(state, payload) {
      state.currentEmployeeId = payload._id;
      let index = state.payrollentries.findIndex(payrollentry => payrollentry._id === payload._id);
      state = Object.assign(state, {
        payrollentries: state.payrollentries.map((payrollentry, i) => {
          if (i === index) {
            return Object.assign({}, payrollentry, payload);
          }
          return payrollentry;
        }),
        isUpdating: false,
        payrollentriesMessage: 'PayrollEntries has been updating!',
      })
    },
    UPDATING_PAYROLL_ENTRY(state) {
      state.isUpdating = true;
    },
    DELETED_PAYROLL_ENTRY(state, payload) {
      let indexToDelete = state.payrollentries.findIndex(payrollentry => payrollentry._id === payload._id);
      console.log(indexToDelete);
      let payrollentries = [...state.payrollentries];
      payrollentries.splice(indexToDelete, 1);
      state = Object.assign(state, {
        payrollentries: [...payrollentries],
        isDeleting: false,
        idToDelete: null,
        payrollentriesMessage: 'PayrollEntry has been Deleted!',
      });
    },
    DELETING_PAYROLL_ENTRY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    setCurrentEmployeeId({dispatch}, id){
      dispatch("updatedCurrentEmployeeId",id);
    },
    getPayrollEntriesRequest({dispatch}) {
      dispatch("receivingPayrollEntries");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/payrollentries';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers}).then(res => {
        dispatch("receivePayrollEntries", res.data);
      })
    },
    updatePayrollEntry({dispatch}, payload) {
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/payrollentry/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updatedPayrollEntry", res.data);
        dispatch("updatedCurrentEmployeeId", res.data.employeeid);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    insertPayrollEntry({dispatch}, payload) {
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/payrollentry';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: payload})
      .then((response) => {
        dispatch("receivedPayrollEntry", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deletePayrollEntryRequest({dispatch}, payload) {
      dispatch("deletingPayrollEntry", payload);
      axios.delete('https://api.accountxc.com:3100/delete/payrollentry/' + payload._id).then(() => {
        dispatch("deletedPayrollEntry", {_id: payload._id});
      })
    },
    updatedCurrentEmployeeId({commit}, id) {
      commit("UPDATED_CURRENT_EMPLOYEEID", id)
    },
    receivePayrollEntries({commit}, payload) {
      commit("RECEIVED_PAYROLL_ENTRIES", payload)
    },
    receivingPayrollEntries({commit}) {
      commit("RECEIVING_PAYROLL_ENTRIES")
    },
    receivedPayrollEntry({commit}, payload) {
      commit("RECEIVED_PAYROLL_ENTRIES", payload)
    },
    receivingPayrollEntry({commit}) {
      commit("RECEIVING_PAYROLL_ENTRY")
    },
    updatedPayrollEntry({commit}, payload) {
      commit("UPDATED_PAYROLL_ENTRY", payload)
    },
    updatingPayrollEntry({commit}) {
      commit("UPDATING_PAYROLL_ENTRY")
    },
    deletedPayrollEntry({commit}, payload) {
      commit("DELETED_PAYROLL_ENTRY", payload)
    },
    deletingPayrollEntry({commit}, payload) {
      commit("DELETING_PAYROLL_ENTRY", payload)
    }
  },
};
